// extracted by mini-css-extract-plugin
export default {"textareaWrapperBackend":"styles_textareaWrapperBackend__bZ4iK","textarea":"styles_textarea__Ki7FI"};